export default __webpack_public_path__ + "static/penn-map-mobile-bfbf3d5ed0d57965224e280227f8f7c0.jpeg";